import { render, staticRenderFns } from "./QuestionEntity.vue?vue&type=template&id=f3ca08ba&scoped=true"
import script from "./QuestionEntity.vue?vue&type=script&lang=js"
export * from "./QuestionEntity.vue?vue&type=script&lang=js"
import style0 from "./QuestionEntity.vue?vue&type=style&index=0&id=f3ca08ba&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3ca08ba",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Mobaxe\\Nevo.SimAdmin.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f3ca08ba')) {
      api.createRecord('f3ca08ba', component.options)
    } else {
      api.reload('f3ca08ba', component.options)
    }
    module.hot.accept("./QuestionEntity.vue?vue&type=template&id=f3ca08ba&scoped=true", function () {
      api.rerender('f3ca08ba', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/QuestionEntity.vue"
export default component.exports